export default function getCSRFToken() {
  const meta = [].slice.call(document.getElementsByTagName('meta')).find((m) => m.name === 'csrf-token');

  return meta && meta.content ? meta.content : null;
}
